import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=e264893a&scoped=true"
import script from "./Options.vue?vue&type=script&lang=js"
export * from "./Options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e264893a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e264893a')) {
      api.createRecord('e264893a', component.options)
    } else {
      api.reload('e264893a', component.options)
    }
    module.hot.accept("./Options.vue?vue&type=template&id=e264893a&scoped=true", function () {
      api.rerender('e264893a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/Options.vue"
export default component.exports